import { h, render } from 'preact';
// import { buildClientStoreData } from 'utils/clientUtils';

import 'base-styles/reset.sss';

import Error404App from 'base/error404/error404App.js';

/* Initial render of the app
----------------------------------*/
render(<Error404App initialStore={window.__INITIAL_STATE__} />, document.body, document.getElementById('app'));
